import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import {
  TextField,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Collapse,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Button,
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";
import SearchIcon from '@mui/icons-material/Search';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { ReactComponent as Hemberger } from '../assets/icons/Hemberger.svg';
import { ReactComponent as UserIcon } from '../assets/icons/UserIcon.svg';
import Sidebar from "../sidenav/Sidenav";
import { hasStoredTabAccess } from '../utils/access';

import { useLocalStorage } from "@uidotdev/usehooks";
import { Link, useNavigate } from "react-router-dom";
import { ArrowBackIosNewRounded } from "@mui/icons-material";
import { toast, ToastContainer } from "react-toastify";

const responseOptions = ['Phone', 'Email', 'Message'];
function formatDateAndTime(date) {
  date = new Date(date);
  let ISTDate = new Date(date.getTime());
  let day = ISTDate.getDate();
  let month = ISTDate.getMonth() + 1;
  let year = ISTDate.getFullYear();
  day = day < 10 ? '0' + day : day;
  month = month < 10 ? '0' + month : month;
  let formattedDate = `${day}.${month}.${year}`;

  let hours = ISTDate.getHours();
  let minutes = ISTDate.getMinutes();
  let AmOrPm = hours >= 12 ? 'pm' : 'am';
  hours = (hours % 12) || 12;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  let formattedTime = `${hours}:${minutes}${AmOrPm}`;
  return { time: formattedTime, date: formattedDate };
}
/* MUI Table */
function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const [openOfEmp, setOpenOfEmp] = React.useState(false);
  const [responseInputs, setResponseInputs] = useState({
    index: null, // index of the row being edited
    respondedThrough: '',
    respondedOn: '',
    respondedBy: '',
    remark: '',
  });
  const empId = localStorage.getItem('userId');
  const handleInputChange = (field, value, msg_id) => {
    setResponseInputs((prev) => ({
      ...prev,
      index: msg_id,
      [field]: value,
    }));
  };
  const handleSaveEnquiries = async () => {
    if(!responseInputs.index || !responseInputs.respondedThrough || !responseInputs.respondedBy || !responseInputs.remark) {
      return;
    }
    const response = await axios.put(`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/contact-us/update/${responseInputs.index}/${empId}`, responseInputs);
    if(response.status === 204) {
      console.log('Enquiry updated successfully');
      toast.success("Enquiry updated successfully", { position: "top-right" });
      setOpenOfEmp(false);
    } else {
      console.error("Error updating enquiry: ", response.data.message);
      toast.error('Error updating enquiry')
    }
  }
  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell component="th" scope="row" sx={{display: 'flex', alignItems: 'center'}}>
          <div>
            <div>{row.name}</div>
            <div>{row.username}</div>
          </div>
          <IconButton
            aria-label="expand row"
            style={{ color: 'black' }}
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell align="right">
          <div style={{display: 'flex', alignItems: 'center'}}>
            <FormControl sx={{ minWidth: 150 }} size="small">
              <InputLabel
                id="responseTitle"
                sx={{ fontSize: "0.75rem" }}
              >
                Responded Through
              </InputLabel>
              <Select
                labelId="responseTitle"
                id="respondedThrough"
                value={responseInputs.index === row.msg_id ? responseInputs.respondedThrough : row.respondedThrough || ''}
                onChange={(e) => handleInputChange('respondedThrough', e.target.value, row.msg_id)}
                label="Responded Through"
                renderValue={(selected) => selected}
                size="small"
                sx={{ textAlign: 'left' }}
              >
                {responseOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    <ListItemText primary={option} />
                    <Checkbox checked={responseInputs.respondedThrough === option} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <IconButton
              aria-label="expand row"
              style={{ color: 'black' }}
              size="small"
              onClick={() => setOpenOfEmp(!openOfEmp)}
            >
              {openOfEmp ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
            </IconButton>
          </div>
        </TableCell>
      </TableRow>
      <TableRow sx={{ "& td": { border: 0, height: open ? 'auto' : 0 }, borderBottom: '1px solid black' }}>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0, borderTop: 'none' }} colSpan={6}>
          <Collapse in={open || openOfEmp} timeout="auto" unmountOnExit  >
              {open ? (
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 150px', rowGap: '6px', fontSize: '10px', marginTop: '4px', marginBottom: '4px' }}>
                  <div>Email: {row.email}</div>
                  <div>Mobile: {row.phone}</div>
                  <div>Date & Time: {formatDateAndTime(row.created_at).date} & {formatDateAndTime(row.created_at).time}</div>
                  <div>Message: {row.message}</div>
                </div>
              ) : (
                <div style={{display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '0.4rem'}}>
                  <div style={{display: 'flex', justifyContent: 'space-between', gap: '0.4rem'}}>
                    <TextField
                      label="Responded on"
                      type="date"
                      value={responseInputs.index === row.msg_id ? responseInputs.respondedOn : (row.updated_at !== row.created_at && row.updated_at.slice(0, 10)) || ''}
                      onChange={(e) => handleInputChange('respondedOn', e.target.value, row.msg_id)}
                      InputProps={{ style: { height: '2.564rem' } }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      // margin="normal"
                    />
                    <TextField
                      size="small"
                      // sx={{m: 1, minWidth: '9.75rem'}}
                      id="user"
                      type="text"
                      name="User"
                      label="Responded by"
                      value={responseInputs.index === row.msg_id ? responseInputs.respondedBy : row.respondedBy || ''}
                      onChange={(e) => handleInputChange('respondedBy', e.target.value, row.msg_id)}
                    />
                  </div>
                  <TextField
                    fullWidth
                    label="Comment"
                    variant="outlined"
                    size="small"
                    sx={{ flex: '1', mt: 1, mb: 1}}
                    value={responseInputs.index === row.msg_id ? responseInputs.remark : row.remark || ''}
                    onChange={(e) => handleInputChange('remark', e.target.value, row.msg_id)}
                  />
                  <Button className="filled-sm" style={{display: row.remark && 'none'}} onClick={handleSaveEnquiries}>
                    Submit
                  </Button>
                </div>
              )}
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const InquiriesMobile = () => {
  const [inquiries, setInquiries] = useState([]);
  const navigate=useNavigate()
  const [filteredInquiries, setFilteredInquiries] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const isAuthorized = hasStoredTabAccess('Enquiries');
  // eslint-disable-next-line no-unused-vars
  const [token, setToken] = useLocalStorage('token', null);

  useEffect(() => {
    const fetchInquiries = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/contact-us`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.status === 200) {
          const sortedData = response.data.data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
          setInquiries(sortedData);
          setFilteredInquiries(sortedData);
        } else {
          console.error("Error fetching inquiries: ", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching inquiries: ", error);
      }
    };

    fetchInquiries();
  }, [token]);

  useEffect(() => {
    applyFilters();
  }, [searchQuery, fromDate, toDate]);

  const applyFilters = () => {
    const filteredData = inquiries.filter((inquiry) => {
      const { name, email, phone, created_at } = inquiry;
      const query = searchQuery.toLowerCase();
      const inquiryDate = new Date(created_at);
      const isWithinDateRange =
        (!fromDate || inquiryDate >= new Date(fromDate)) &&
        (!toDate || inquiryDate <= new Date(toDate));
      return (
        (name.toLowerCase().includes(query) ||
          email.toLowerCase().includes(query) ||
          phone.toLowerCase().includes(query)) &&
        isWithinDateRange
      );
    });

    setFilteredInquiries(filteredData);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleFromDateChange = (e) => {
    setFromDate(e.target.value);
  };

  const handleToDateChange = (e) => {
    setToDate(e.target.value);
  };
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  if (!isAuthorized) {
    return (
      <div className="container-fluid mt-5">
        <h2>You are unauthorized to access this page</h2>
      </div>
    );
  }

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '0.5rem 0.75rem 1.25rem 0.75rem' }}>
        <div onClick={() => setIsSidebarOpen(!isSidebarOpen)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', width: '36px', height: '36px', borderRadius: '18px', background: '#EAF1F7' }}>
          <Hemberger />
        </div>
        <Link to="/profile">
        <UserIcon style={{ cursor: 'pointer' }} />
        </Link>
      </div>
      <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />

      <div className="container-fluid">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
        <div
              style={{
                display: "flex",
                gap: "1vw",
                alignItems: "center",
                // marginBottom:"2.25rem"
              }}
            >
              <ArrowBackIosNewRounded
                onClick={() => {
                  navigate("/dashboard");
                }}
                style={{ cursor: "pointer" }}
              />
              <h4 style={{ marginRight: "1rem", marginBottom: "0px" }}>
                Enquiries
              </h4>
            </div>
          <TextField
            style={{ marginRight: "0" }}
            value={searchQuery}
            onChange={handleSearchChange}
            variant="outlined"
            placeholder="Search"
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: 'transparent',
                },
                '&:hover fieldset': {
                  borderColor: 'transparent',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'transparent',
                  boxShadow: 'none',
                },
              },
            }}
            InputProps={{
              style: {
                width: '8.75rem',
                height: '1.75rem',
                paddingRight: '0.2rem',
                boxShadow: '0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A'
              },
              endAdornment: <SearchIcon />,
            }}
            margin="normal"
          />
        </div>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'end', gap: '8px' }}>
          <TextField
            label="From Date"
            type="date"
            value={fromDate}
            onChange={handleFromDateChange}
            InputProps={{
              style: {
                width: '8.9rem',
                height: '1.75rem'
              }
            }}
            InputLabelProps={{
              shrink: true,
            }}
            margin="normal"
            style={{
              marginRight: "1vw"
            }}
          />
          <TextField
            label="To Date"
            type="date"
            value={toDate}
            onChange={handleToDateChange}
            InputProps={{
              style: {
                width: '8.9rem',
                height: '1.75rem'
              }
            }}
            InputLabelProps={{
              shrink: true,
            }}
            margin="normal"
          />
        </div>
        <Table aria-label="collapsible table" sx={{
          [`& .${tableCellClasses.root}`]: {
            borderBottom: "none"
          }
        }}>
          <TableHead style={{ height: '44px', borderRadius: '4px !important', background: 'rgba(234, 241, 247, 1)', boxShadow: '2px 2px 4px 0px rgba(174, 174, 192, 0.5)' }}>
            <TableRow>
              <TableCell>Name & Username</TableCell>
              <TableCell align="right">Response</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredInquiries?.map((inquiry) => (
              <Row key={inquiry.attempt_id} row={inquiry} />
            ))}
          </TableBody>
        </Table>
      </div>
      <ToastContainer />
    </>
  );
};

export default InquiriesMobile;